import React, { useState } from 'react';
import LicenseGate from '../components/ui/LicenseGate';
import { ProductCategorySalesTrend, ClubParametersTable, SalesParametersTable } from '../components/club';
import ClubGuideModal from '../components/club/ClubGuideModal';
import { TourLauncher, useDashboardTour } from '../components/ui/tour';
import { CLUB_TOUR } from '../utils/clubTour';
import { TimePeriod } from '../types/api';

interface ClubDashboardProps {
  branchId?: number;
  currency?: string;
  customTimeRange?: TimePeriod;
}

const ClubDashboard: React.FC<ClubDashboardProps> = ({
  branchId = 0, // Default to اندرزگو branch
  currency, // Default to اندرزگو branch
  customTimeRange
}) => {
  const { startTour } = useDashboardTour(CLUB_TOUR, { storageKey: 'tour:club' });
  const [guideOpen, setGuideOpen] = useState(false);

  return (
    <LicenseGate licenseType="club" dashboardName="داشبورد جامع باشگاه مشتریان">
      <div dir="rtl" className="container-dashboard">
        <div className="space-y-8 md:space-y-10 animate-enter-up">
          {/* Header */}
          <div>
            {/* نوار ابزارِ راهنما در گوشه‌ی بالا (تراز چپ در RTL) */}
            <div className="flex justify-end mb-3">
              <TourLauncher
                onStartTour={startTour}
                onOpenGuide={() => setGuideOpen(true)}
                guideButtonTourId="club-guide-btn"
              />
            </div>
            <h1 className="title-dashboard">
              باشگاه مشتریان
            </h1>
          </div>

          {/* Product Category Sales Trend
          <div className="animate-scale-in stagger-2">
            <ProductCategorySalesTrend 
              branchId={branchId}
              timeRange={customTimeRange}
            />
          </div> */}

          <div id="section-club-parameters" className="dashboard-section-anchor" data-tour="club-params">
            <ClubParametersTable
              branchId={branchId}
              currency={currency}
              timeRange={customTimeRange}
            />
          </div>

          <div id="section-sales-parameters" className="dashboard-section-anchor" data-tour="club-sales">
            <SalesParametersTable
              branchId={branchId}
              currency={currency}
              timeRange={customTimeRange}
            />
          </div>
        </div>

        {/* راهنمای کامل (Modal متنی) */}
        <ClubGuideModal isOpen={guideOpen} onClose={() => setGuideOpen(false)} />
      </div>
    </LicenseGate>
  );
};

export default ClubDashboard;
